import { useQuery } from '@apollo/client';
import { AUTHENTICATION_TYPES } from '@seek/apac-candidate-header-footer/types';

import { useConfig } from 'src/context/config';
import { useJobId } from 'src/context/useJobId';
import { logError } from 'src/modules/error-logger/browserLog';
import { getOperationNameFromQuery } from 'src/modules/utils';
import { didResolverErrorOccur } from 'src/utils';

import { useAuthenticationStatus } from '../use-user';

import { GET_JOB, GET_JOB_APPLICATION_PROCESS } from './graphql/jobs.graphql';

export const useJobDetails = () => {
  const jobId = useJobId();
  const { config } = useConfig();
  const { data, loading, error } = useQuery(GET_JOB, {
    variables: { jobId, locale: config.VOCAB_LANGUAGE },
    onError(err) {
      logError(
        {
          message: 'Failed to resolve jobDetails',
          graphQLErrors: err.graphQLErrors,
          type: 'jobdetails-fetch-failed',
        },
        { jobId, operationName: getOperationNameFromQuery(GET_JOB) },
      );
    },
  });
  return {
    data: data?.jobDetails?.job,
    loading,
    error,
  };
};

export const useApplicationProcess = () => {
  const jobId = useJobId();
  const authenticationStatus = useAuthenticationStatus();
  const { config } = useConfig();
  const isAuthenticated =
    authenticationStatus === AUTHENTICATION_TYPES.AUTHENTICATED;

  const { data, loading, error } = useQuery(GET_JOB_APPLICATION_PROCESS, {
    variables: { jobId, isAuthenticated, locale: config.VOCAB_LANGUAGE },
    // data become undefined even when cache hit
    // casued by potential mismatch of mock data in dev env
    // temp fix by returnPartialData
    returnPartialData: true,
    onError(err) {
      const hasError = didResolverErrorOccur(
        ['jobApplicationProcess', 'questionnaire'],
        err.graphQLErrors,
      );
      if (hasError) {
        logError(
          {
            message: 'Failed to resolve questionnaire',
            graphQLErrors: err.graphQLErrors,
            type: 'questionnaire-fetch-failed',
          },
          {
            jobId,
            operationName: getOperationNameFromQuery(
              GET_JOB_APPLICATION_PROCESS,
            ),
          },
        );
      }
    },
  });

  return {
    data: data?.jobApplicationProcess,
    loading,
    error,
  };
};
